<input type="checkbox" id="findMatchDiacritics" class="toolbarField" />
<label for="findMatchDiacritics" class="toolbarLabel" data-l10n-id="pdfjs-find-match-diacritics-checkbox-label">Match Diacritics</label>
